import { F0Box, F0Button } from '@factorialco/f0-react'
import { Add, Minus, GroupBy } from '@factorialco/f0-react/icons/app'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import {
  type FitViewOptions,
  type ViewportHelperFunctionOptions,
  useReactFlow,
} from '@xyflow/react'

import i18n from 'modules/core/lib/i18n'
import { TREE_FIT_VIEW_OPTIONS } from 'modules/job_catalog/components/JobCatalogTree/constants'

const zoomingOptions: ViewportHelperFunctionOptions = { duration: 300 }
const fitViewOptions: FitViewOptions = TREE_FIT_VIEW_OPTIONS

const ZoomControls = () => {
  const { fitView, zoomIn, zoomOut } = useReactFlow()
  const zoomInLabel = i18n.t('job_catalog.job_catalog_tree.zoom_controls.zoom_in')
  const zoomOutLabel = i18n.t('job_catalog.job_catalog_tree.zoom_controls.zoom_out')
  const fitViewLabel = i18n.t('job_catalog.job_catalog_tree.zoom_controls.fit_view')

  return (
    <F0Box display="flex" flexDirection="column" gap="sm">
      <Tooltip label={zoomInLabel}>
        <F0Button
          icon={Add}
          label={zoomInLabel}
          hideLabel
          variant="outline"
          onClick={() => zoomIn(zoomingOptions)}
        />
      </Tooltip>
      <Tooltip label={zoomOutLabel}>
        <F0Button
          icon={Minus}
          label={zoomOutLabel}
          hideLabel
          variant="outline"
          onClick={() => zoomOut(zoomingOptions)}
        />
      </Tooltip>
      <Tooltip label={fitViewLabel}>
        <F0Button
          icon={GroupBy}
          label={fitViewLabel}
          hideLabel
          variant="outline"
          onClick={() => fitView(fitViewOptions)}
        />
      </Tooltip>
    </F0Box>
  )
}

export default ZoomControls
